import React, { useEffect, useState } from "react";

// components
import Button from "../../../../../components/Button";
import Input from "../../../../../components/Inputs/InputText";
import FormModal from "../../../../../components/Modal/Templates/FormModal";
import Typography from "../../../../../components/Text";

// hooks
import { useCreateCompanyForm } from "../../../../../api/hooks";
import useNavigate from "../../../../../hooks/useNavigate";

import { MAX_NAME_LENGTH } from "../../EditForm/utils";

type CreateFormModalProps = {
	isOpen: boolean;
	handleClose: () => void;
};

const CreateFormModal = ({ isOpen, handleClose }: CreateFormModalProps) => {
	const navigate = useNavigate();
	const [name, setName] = useState("");
	const [error, setError] = useState("");
	const { mutate: createForm, isPending } = useCreateCompanyForm({
		onSuccess: (response) => {
			handleClose();
			//need to use redux navigation here since I think navigating to a template page is happening while react is still gathering new state
			//it hasn't yet propagated new search params since the render hasn't yet finished, but using the redux rerouting will wait for the renders to finish since its quite a bit slower
			navigate(`/edit-review-form/${response?._id}`);
		},
	});

	useEffect(() => {
		if (isOpen) {
			setName("");
			setError("");
		}
	}, [isOpen]);

	return (
		<FormModal
			isOpen={isOpen}
			handleClose={handleClose}
			onSubmit={(e) => {
				e.preventDefault();
				if (!name) {
					setError("Name cannot be empty.");
				} else if (name.length > MAX_NAME_LENGTH) {
					setError(`Name must be less than ${MAX_NAME_LENGTH} characters.`);
				} else {
					setError("");
					createForm({ name });
				}
			}}
			title={
				<Typography weight="semi-bold" size="sub-heading">
					Create New Form
				</Typography>
			}
			buttons={[
				<Button key="cancel" onClick={handleClose} testid="cancelButton">
					Cancel
				</Button>,
				<Button key="save" isRequesting={isPending} color="green" testid="createFormButton" submit>
					Create New Form
				</Button>,
			]}
		>
			<Input
				label="Form Name"
				value={name}
				onChange={(value) => setName(value)}
				placeholder="New Form Name"
				autoFocus
				errorMessage={error}
				animatedError
			/>
		</FormModal>
	);
};

export default CreateFormModal;
